import { TableCellText } from "@ceridianhcm/components";
import { FormatFullDate } from "../../common/formatting";

export const CommonBlockFileName = () => {
    const fileNameObject = {
        field: "fileName",
        label: "File Name",
        cellTemplate: (cellContext: any) => (
        <TableCellText>
            <div title={cellContext.rowData.fileName}>
            {cellContext.rowData.fileName}
            </div>
        </TableCellText>
        ),
    }
    return fileNameObject;
};

export const CommonBlockPayDate = () => {
    const payDateObject = {
            field: "payDate",
            label: "Pay date",
            cellTemplate: (cellContext: any) => (
              <TableCellText>
                <div title={cellContext.rowData.payDate}>
                  {FormatFullDate(cellContext.rowData.payDate)}
                </div>
              </TableCellText>
            )
    };
    return payDateObject;
};
 

export const CommonBlockPeriodEndDate = () => {
    const periodEndDateObject = {
        field: "periodEndDate",
        label: "Period EndDate",
        cellTemplate: (cellContext: any) => (
          <TableCellText>
            <div title={cellContext.rowData.periodEndDate}>
              {FormatFullDate(cellContext.rowData.periodEndDate)}
            </div>
          </TableCellText>
        ),
    };
    return periodEndDateObject;
};

